<template>
  <div>
    <div class="card">
      <div class="card-header">
        <a-form :form="form" layout="inline">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-xl-7">
                  <div class="row">
                    <div class="col-md-9 offset-md-4">
                      <a-form-item
                        :label-col="labelCol"
                        :wrapper-col="wrapperCol"
                        style="width: 360px"
                        :label="$t('Keyword')"
                      >
                        <a-input
                          :placeholder="$t('Keyword')"
                          v-decorator="[
                            'keyword',
                            {
                              initialValue: '',
                              rules: [
                                {
                                  required: false,
                                  message: '',
                                },
                              ],
                            },
                          ]"
                          @pressEnter="handleFilter"
                        />
                      </a-form-item>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5">
                  <div class="col-md-10">
                    <a-button
                      type="button"
                      class="btn btn-success mt-1 mb-1"
                      @click="handleFilter"
                      :loading="searching"
                    >
                      {{ $t('Search') }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-form>
      </div>
      <div class="card-body">
        <a-form :form="form" layout="inline">
          <a-table
            :columns="columns"
            :dataSource="data"
            :pagination="false"
            :locale="table_locale"
            :loading="searching"
          >
            <a-form-item slot="view" slot-scope="text, record">
              <a-checkbox
                v-decorator="[
                  'view',
                  { initialValue: record.permissions.view },
                ]"
              >
              </a-checkbox>
            </a-form-item>
            <a-form-item slot="create" slot-scope="text, record">
              <a-checkbox
                v-decorator="[
                  'create',
                  { initialValue: record.permissions.create },
                ]"
              >
              </a-checkbox>
            </a-form-item>
            <a-form-item slot="update" slot-scope="text, record">
              <a-checkbox
                v-decorator="[
                  'update',
                  { initialValue: record.permissions.update },
                ]"
              >
              </a-checkbox>
            </a-form-item>
            <a-form-item slot="delete" slot-scope="text, record">
              <a-checkbox
                v-decorator="[
                  'delete',
                  { initialValue: record.permissions.delete },
                ]"
              >
              </a-checkbox>
            </a-form-item>
          </a-table>
        </a-form>
        <div class="col-md-12" style="padding: 1.33rem 0">
          <a-pagination
            v-model="current_page"
            :total="last_page"
            @change="handleFilter"
          />
        </div>
        <div class="text-right">
          <router-link :to="{ name: 'role-management' }">
            <a-button type="button" class="btn btn-success mt-1 mb-1">
              {{ $t('Back') }}
            </a-button>
          </router-link>
          <a-button type="primary" style="margin-left: 1rem" @click="onAdd">
            {{ $t('Save') }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import _ from 'lodash';
const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
};
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 20 },
};
export default {
  data: function () {
    const columns = [
      {
        title: '#',
        dataIndex: 'row_number',
        scopedSlots: { customRender: 'row_number' },
      },
      {
        title: this.$t('Menu Name'),
        dataIndex: 'name',
      },
      {
        title: this.$t('View Data'),
        dataIndex: 'view',
        align: 'center',
        scopedSlots: { customRender: 'view' },
      },
      {
        title: this.$t('Create Data'),
        dataIndex: 'create',
        align: 'center',
        scopedSlots: { customRender: 'create' },
      },
      {
        title: this.$t('Update Data'),
        dataIndex: 'update',
        align: 'center',
        scopedSlots: { customRender: 'update' },
      },
      {
        title: this.$t('Delete Data'),
        dataIndex: 'delete',
        align: 'center',
        scopedSlots: { customRender: 'delete' },
      },
    ];
    return {
      form: this.$form.createForm(this),
      searchText: '',
      searching: false,
      current_page: 1,
      last_page: 1,
      columns,
      labelCol,
      wrapperCol,
      data: [
        {
          name: 'Test',
          permissions: {
            view: true,
            create: true,
            update: false,
            delete: true,
          },
        },
      ],
      table_locale: {
        filterConfirm: this.$t('Ok'),
        filterReset: this.$t('Reset'),
        emptyText: this.$t('No Data'),
      },
    };
  },
  mounted() {
    this.handleFilter();
  },
  methods: {
    handleFilter(current_page = null) {
      if (typeof current_page != 'number') current_page = this.current_page;
      this.form.validateFields((err, values) => {
        if (!err) {
          // this.searching = true;
          // this.$store.dispatch('user/POST', {
          //   payload: {
          //     path: '/api/console/roles/permission/all',
          //     data: {
          //       pageNo: current_page,
          //       itemPerPage: 20,
          //       ...values,
          //     },
          //     callback: (res) => {
          //       if (res && res.data) {
          //         if (res.current_page) this.current_page = res.current_page;
          //         if (res.last_page) this.last_page = res.last_page * 10;
          //         if (_.isArray(res.data)) {
          //           this.data = _.filter(
          //             res.data,
          //             (v, k) =>
          //               (v.row_number =
          //                 (this.current_page > 1
          //                   ? 20 * (this.current_page - 1)
          //                   : 0) +
          //                 k +
          //                 1)
          //           );
          //           console.log('this.data', this.data);
          //         }
          //       }
          //       this.searching = false;
          //     },
          //   },
          // });
        }
      });
    },
    onAdd() {},
    onDelete() {},
  },
};
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
